<template>
<section class="home" id="home">
  <div class="text-container">
    <div class="job-name">
      <h1 class="text-animation" data-text="FrontEnd">FrontEnd </h1>
      <h1 class="normal">Developer</h1>
    </div>
     <div class="name">
      <h2> <span class="glitch-text" data-text="Olivier">Olivier</span> </h2>
    </div>
    <div class="more">
      <a href="#about"><span class="material-icons"> expand_more </span></a>
    </div>
  </div>
</section>
</template>

<script>
export default {
    name: "Home",
}
</script>

<style scoped>
  .home {
    background: rgba(0,0,0,0.45) url('@/assets/Home.jpg');
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-blend-mode: darken;
    min-height: 100vh;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .job-name {
    display: flex;
  }

  .job-name h1.normal {
    padding-left: 1.5rem;
  }

   .job-name h1 {
    color: transparent;
    font-size: 7.5rem;
    text-transform: uppercase;
    position: relative;
    /* -webkit-text-stroke: 0.3rem #ff8906; */
    color: crimson;
    font-family: 'Poppins', sans-serif;
  }

  h1.text-animation::before {
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    color: #ff8906;
    overflow: hidden;
    position: absolute;
    content: attr(data-text);
    -webkit-text-stroke: 0vw #ff8906;
    animation: animate 5.5s linear infinite;
  }

  @keyframes animate {
    0%,
    10%,
    100% {
      width: 0;
    }
    70%,
    90% {
      width: 100%;
    }
  }

  .name h2 {
      font-size: 4rem;
      text-align: center;
      font-family: sans-serif;
      position: relative;
  }

  .name h2 .glitch-text{
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    transform: scale(2);
    letter-spacing: 2px;
    padding: 30px 0;
    font-family: sans-serif;
  }

  .name h2 .glitch-text::before,
  .name h2 .glitch-text::after {
  content: attr(data-text);
  position: absolute;
  width: 99.5%;
  height: 100%;
  overflow: hidden;
  font-family: sans-serif;
  }



  .name h2 .glitch-text::before {
      left: 3px;
      text-shadow: -2px 0 crimson;
      animation: glitch-1 3s linear infinite reverse;
  }


  .name h2 .glitch-text::after {
    left: -3px;
    text-shadow: -2px 0 crimson;
    animation: glitch-2 3s linear infinite reverse;
  }


  @keyframes glitch-1 {
  0% {
    clip: rect(132px, auto, 101px, 30px);
  }
  5% {
    clip: rect(17px, auto, 94px, 30px);
  }
  10% {
    clip: rect(40px, auto, 66px, 30px);
  }
  15% {
    clip: rect(87px, auto, 82px, 30px);
  }
  20% {
    clip: rect(137px, auto, 61px, 30px);
  }
  25% {
    clip: rect(34px, auto, 14px, 30px);
  }
  30% {
    clip: rect(133px, auto, 74px, 30px);
  }
  35% {
    clip: rect(76px, auto, 107px, 30px);
  }
  40% {
    clip: rect(59px, auto, 130px, 30px);
  }
  45% {
    clip: rect(29px, auto, 84px, 30px);
  }
  50% {
    clip: rect(22px, auto, 67px, 30px);
  }
  55% {
    clip: rect(67px, auto, 62px, 30px);
  }
  60% {
    clip: rect(10px, auto, 105px, 30px);
  }
  65% {
    clip: rect(78px, auto, 115px, 30px);
  }
  70% {
    clip: rect(105px, auto, 13px, 30px);
  }
  75% {
    clip: rect(15px, auto, 75px, 30px);
  }
  80% {
    clip: rect(66px, auto, 39px, 30px);
  }
  85% {
    clip: rect(133px, auto, 73px, 30px);
  }
  90% {
    clip: rect(36px, auto, 128px, 30px);
  }
  95% {
    clip: rect(68px, auto, 103px, 30px);
  }
  100% {
    clip: rect(14px, auto, 100px, 30px);
  }
}

@keyframes glitch-2 {
  0% {
    clip: rect(129px, auto, 36px, 30px);
  }
  5% {
    clip: rect(36px, auto, 4px, 30px);
  }
  10% {
    clip: rect(85px, auto, 66px, 30px);
  }
  15% {
    clip: rect(91px, auto, 91px, 30px);
  }
  20% {
    clip: rect(148px, auto, 138px, 30px);
  }
  25% {
    clip: rect(38px, auto, 122px, 30px);
  }
  30% {
    clip: rect(69px, auto, 54px, 30px);
  }
  35% {
    clip: rect(98px, auto, 71px, 30px);
  }
  40% {
    clip: rect(146px, auto, 34px, 30px);
  }
  45% {
    clip: rect(134px, auto, 43px, 30px);
  }
  50% {
    clip: rect(102px, auto, 80px, 30px);
  }
  55% {
    clip: rect(119px, auto, 44px, 30px);
  }
  60% {
    clip: rect(106px, auto, 99px, 30px);
  }
  65% {
    clip: rect(141px, auto, 74px, 30px);
  }
  70% {
    clip: rect(20px, auto, 78px, 30px);
  }
  75% {
    clip: rect(133px, auto, 79px, 30px);
  }
  80% {
    clip: rect(78px, auto, 52px, 30px);
  }
  85% {
    clip: rect(35px, auto, 39px, 30px);
  }
  90% {
    clip: rect(67px, auto, 70px, 30px);
  }
  95% {
    clip: rect(71px, auto, 103px, 30px);
  }
  100% {
    clip: rect(83px, auto, 40px, 30px);
  }
}
 

  .more {
    position: absolute;
    top: 92%;
    left: 48.5%;
    z-index: 999;
    animation: scrollDown 3s ease-in-out infinite;
  }

  .more a {
    color: #fff;
    text-decoration: none;
  }

  .material-icons {
    font-size: 3.5rem;
  }

  @keyframes scrollDown {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(18px);
    }

    100% {
      transform: translateY(0px);
    }
  }


  @media (min-width: 2250px){
 .job-name h1.normal {
    padding-left: 2rem;
  }

  .job-name h1 {
    font-size: 9rem;
  }

    .name h2 {
      font-size: 5.2rem;
    }

    .more {
    top: 91.5%;
    left: 48%;
  }

  .material-icons {
    font-size: 5.3rem;
    
  }
  }


  @media (max-width: 1440px) {

    .home {
      background-position: center;
    }

    .job-name h1 {
        font-size: 5.6rem;
    }

    .name h2 {
      font-size: 3.8rem;
    }

  }

    @media (max-width: 1024px) {
      .job-name h1 {
        font-size: 4.6rem;
    }

    .name h2 {
      font-size: 3rem;
    }

    .job-name h1.normal {
        padding-left: 1.2rem;
        }

        
      .more {
    top: 91.5%;
  }

  .material-icons {
    font-size: 3.3rem;
  }
    }

     @media (max-width: 768px) {
      .job-name {
        flex-direction: column;
      }

      .job-name h1 {
        font-size: 5.2rem;
    }

      .job-name h1.normal {
        padding-left: 0;
        margin-top: -1.5rem;
        }

      .job-name h1.text-animation {
        
        position: relative;
        top: 50%;
        left: 3%;
      }

      .name h2 {
      font-size: 3rem;
    }

   .more {
    top: 91.7%;
  }
     }

     @media (max-width: 425px) {

      .home {
        background: rgba(0,0,0,0.45) url('@/assets/Home-mobile.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
         background-blend-mode: darken;
        min-height: 100vh;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

            .job-name h1 {
        font-size: 4.5rem;
    }

    .name h2 {
      font-size: 2.9rem;
    }

      .more {
        top: 90%;
        left: 43.5%;
  }

    .material-icons {
    font-size: 3.2rem;
  }
     }

     @media(max-width: 395px) {
         .job-name h1 {
        font-size: 3.85rem;
    }

    .name h2 {
      font-size: 2.65rem;
    }

    .material-icons {
    font-size: 3.1rem;
  }

  .more {
        top: 88.5%;
        left: 43.5%;
  }

     }

     @media(max-width: 350px) {
      .job-name h1 {
        font-size: 3.3rem;
    }

    .name h2 {
      font-size: 2.15rem;
    }

       .more {
    top: 87.5%;
  }

  .material-icons {
    font-size: 3.3rem;
  }
     }


</style>